'use strict';

module.exports = {
  init({ goodsUkShipping }) {
    if (!goodsUkShipping) {
      return;
    }

    const $container = document.querySelector('#goods-uk-shipping');
    const $shippingValue = $container.querySelector('.shipping-value');

    window.DealEventPipe.on('goodsOptionUpdate', ({ uuid }) => {
      const shippingValue = goodsUkShipping[uuid];
      if (shippingValue) {
        $container.classList.remove('hidden');
        $shippingValue.textContent = shippingValue;
      } else {
        $container.classList.add('hidden');
      }
    });
  },
};
